import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import AddProjectsColumns from "./columns";
import Table from "../../../../../../components/table/table";
import { useUnlinkedProjects } from "../../../../../../hooks/useUnlinkedProjects";
import { projectsCollection } from "../../../../../../services/firebase";
import { Typography } from "@mui/material";
import { AddProjectsModalStyled } from "./add-projects-modal.styles";

const AddProjectsModal = ({ onClose, projectData, onSuccess }) => {
  const { id } = useParams();
  const [selectedProjects, setSelectedProjects] = useState([]);

  const { unlinkedProjects = [], isLoading } = useUnlinkedProjects();

  // Handle Confirm button click
  const handleConfirm = async () => {
    try {
      const batch = projectsCollection.firestore.batch();

      selectedProjects.forEach((projectId) => {
        const projectRef = projectsCollection.doc(projectId);
        batch.update(projectRef, { addToExistingProject: id });
      });

      await batch.commit();

      // Call onSuccess to refresh the parent table
      onSuccess();
      onClose();
    } catch (error) {
      console.error("Error adding projects to group:", error);
    }
  };
  return (
    <AddProjectsModalStyled
      confirmBtnTitle="Add Project(s)"
      closeBtnTitle="Cancel"
      // isConfirming={isDataUpdating}
      disableConfirmBtn={false}
      onConfirm={handleConfirm}
      onClose={onClose}
    >
      <div className="body">
        <div className="heading">
          <Typography
            variant={"body2"}
          >{`ID: ${id} | ${projectData.projectName}`}</Typography>
          <Typography variant={"h4"}>
            Select project(s) to add to your group
          </Typography>
        </div>
        <div className="table">
          <Table
            data={unlinkedProjects}
            columns={AddProjectsColumns(selectedProjects, setSelectedProjects)}
            noDataMessage={"No project groups available"}
            sortable
            stickyHeader={true}
            isLoading={isLoading}
          />
        </div>
      </div>
    </AddProjectsModalStyled>
  );
};

export default AddProjectsModal;
